import { render, staticRenderFns } from "./propertyManagementForm.vue?vue&type=template&id=d57ffc08"
import script from "./propertyManagementForm.vue?vue&type=script&lang=js"
export * from "./propertyManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports